export default __webpack_public_path__ + "static/media/giftWhite.a8597746.svg";